import { AlertCircle } from 'lucide-react';
import type { ReactNode } from 'react';
import { cn } from '../../lib/cn';

export interface ErrorBannerProps {
  message: ReactNode;
  className?: string;
}

export function ErrorBanner({ message, className }: ErrorBannerProps) {
  return (
    <div
      role="alert"
      className={cn(
        'flex items-start gap-2 rounded-[14px] border border-error/30 bg-red-50 px-3.5 py-2.5 text-sm text-error',
        className,
      )}
    >
      <AlertCircle size={16} className="mt-0.5 shrink-0" />
      <span>{message}</span>
    </div>
  );
}
